const CountryFlag = ({ country_code, className = 'inline-block h-3 w-auto align-middle' }) => {
  if (!country_code) return null
  return (
    <img
      className={className}
      src={`https://tm2-assets.ams3.cdn.digitaloceanspaces.com/system/assets/sales/images/country-flags/${country_code.toLowerCase()}.png`}
      alt={`${country_code} flag`}
    />
  )
}

export default CountryFlag
